.root {
    flex: 1;
    flex-direction: column;
    background: var(--exwo-color-app-bg);
    overflow: hidden;
    width: 100%;
    height: 100%;
}

.scrollRoot {
    flex: 1;
    width: 100%;
    height: 100%;
}

.scrollViewport {
    padding: 2.5rem 3rem 3rem;
}

.content {
    width: 100%;
    max-width: 80rem;
    margin: 0 auto;
}

.topBar {
    width: 100%;
    margin-bottom: -0.5rem;
}
